import Badge from "@/components/Badge";
import Pagination from "@/components/Pagination";
import Table from "@/components/Table";
import BodyImageWithInfoColumn from "@/components/Table/table-body/BodyImageWithInfoColumn";
import HeaderColumn from "@/components/Table/table-header/HeaderColumn";
import { ReactComponent as EYE_ICON } from "@/assets/icons/eye.svg";
import { useNavigate } from "react-router-dom";
import { ChangeEvent, useEffect, useMemo, useState } from "react";
import { Stock } from "@/@core/entity/stock.entity";
import getStockInteractor from "@/@core/interactor/stock/get-stocks.interactor";
import Button from "@/components/Button";
import SelectImage from "@/components/SelectImage";
import Dropdown from "@/components/Dropdown";
import Modal from "@/components/Modal";
import getProductInteractor from "@/@core/interactor/product/get-product";
import { Product } from "@/@core/entity/product.entity";
import getWarehouseInteractor from "@/@core/interactor/warehouse/get-warehouse.interactor";
import { Warehouse } from "@/@core/entity/warehouse.entity";
import { stringToDate } from "@/utils/date";
import { Toaster, toast } from "react-hot-toast";
import uploadStockTransferInteractor from "@/@core/interactor/batch-uploads/upload-stock-transfer.interactor";
import Input from "@/components/Input";

const STOCK_STATUS_OPTIONS = [
  {
    label: "Lock",
    value: "lock",
  },
  {
    label: "Unlock",
    value: "unlock",
  },
];

interface TableSectionProps {
  showModalAdd: boolean;
  setShowModalAdd: React.Dispatch<React.SetStateAction<boolean>>;
}

let debounceSearch: any;

const TableSection = (props: TableSectionProps) => {
  const navigate = useNavigate();
  const { showModalAdd, setShowModalAdd } = props;

  const [stockQuatities, setStockQuatities] = useState<Stock[]>([]);
  const [listProduct, setListProduct] = useState<Product[]>([]);
  const [listWarehouse, setListWarehouse] = useState<Warehouse[]>([]);

  const [activePage, setActivePage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string>("");

  const [product, setProduct] = useState<any>();
  const [warehouseSource, setWarehouseSource] = useState<any>();
  const [warehouseTarget, setWarehouseTarget] = useState<any>();
  const [fileCsv, setFileCsv] = useState<File | null>(null);
  const [isFetch, setIsFetch] = useState<boolean>(false);

  const csvExtension = ["text/csv", "application/vnd.ms-excel"];
  const isErrorFile = useMemo(() => {
    return !fileCsv || csvExtension.indexOf(fileCsv?.type) === -1;
  }, [fileCsv]);
  const [stockStatus, setStockStatus] = useState(STOCK_STATUS_OPTIONS[0]);

  const getBody = () => {
    return {
      product_id: product.value,
      warehouse_target_id: warehouseTarget.value,
      warehouse_source_id: warehouseSource.value,
      file: fileCsv,
      is_lock: stockStatus.value === "lock" ? true : false,
    };
  };

  const createTransferStock = async () => {
    setIsFetch(true);
    try {
      const body = getBody();
      //@ts-ignore
      const response = await uploadStockTransferInteractor(body);
      const { status } = response;

      if (status === 200) {
        toast.success("Uploaded successfully!");
        getStockQuantity(activePage);
        setShowModalAdd(!showModalAdd);
        setIsFetch(false);
      }
    } catch (error: any) {
      const { response } = error;
      const {
        data: { message },
      } = response;

      toast.error(message);
      setIsFetch(false);
    }
  };

  const getStockQuantity = async (page: number, serial_number = "") => {
    try {
      const response = await getStockInteractor({
        limit: 5,
        page,
        serial_number,
        type: 2,
      });

      const {
        data: { data, pagination },
      } = response;

      setStockQuatities(data);
      if (pagination) {
        setActivePage(pagination.current_page);
        setTotalPage(pagination.last_page);
      }
    } catch (error: any) {
      setStockQuatities([]);
      setActivePage(1);
      setTotalPage(1);
    }
  };

  const getProducts = async () => {
    try {
      const response = await getProductInteractor({});
      const {
        data: { data },
      } = response;
      setListProduct(data);
    } catch (error: any) {
      setListProduct([]);
    }
  };
  console.log(listProduct)
  
  const getWarehouse = async () => {
    try {
      const response = await getWarehouseInteractor({});
      const {
        data: { data },
      } = response;
      const newData = data.filter((warehouse) => warehouse.is_active === true);
      setListWarehouse(newData);
    } catch (error: any) {
      setListWarehouse([]);
    }
  };

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setFileCsv(file || null);
    if (file) {
      console.log("Uploaded file:", file);
    }
  };

  const onChangeKeyword = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setKeyword(val);

    clearTimeout(debounceSearch);
    debounceSearch = setTimeout(() => {
      getStockQuantity(1, val);
    }, 2000);
  };

  const onKeywordEnter = (e: any) => {
    const keyCode = e.keyCode;
    const val = e.target.value;

    if (keyCode === 13) {
      clearTimeout(debounceSearch);
      getStockQuantity(1, val);
    }
  };

  const resetFilter = () => {
    getStockQuantity(1, "");
    setKeyword("");
  };

  const onChangePagination = (e: any) => {
    setActivePage(e);
    getStockQuantity(e);
  };

  useEffect(() => {
    getStockQuantity(activePage);
    getProducts();
    getWarehouse();
  }, []);

  return (
    <>
      <div className='table-control-section'>
        <div>
          <label>Search for UID</label>
          <Input
            style={{ width: "360px" }}
            value={keyword}
            withIcon
            type='search'
            placeholder='UID,UID,UID'
            onChange={onChangeKeyword}
            onKeyDown={onKeywordEnter}
          />
        </div>
        <div className="btn-wrapper">
          <Button
            onClick={resetFilter}
            label="Reset Filter"
            type="secondary"
            size="md"
            disabled={!keyword}
          />
        </div>
      </div>

      <div className="table-section">
        <Table>
          <thead>
            <tr>
              <HeaderColumn label="Transfer ID" alignLabel="text-left" />
              <HeaderColumn label="Product" alignLabel="text-left" />
              <HeaderColumn label="Status" alignLabel="text-center" />
              <HeaderColumn label="Transfered" alignLabel="text-center" />
              <HeaderColumn label="Warehouse" alignLabel="text-center" />
              <HeaderColumn label="Created by" alignLabel="text-center" />
              <HeaderColumn label="Created at" alignLabel="text-left" />
              <HeaderColumn label="" alignLabel="text-left" />
            </tr>
          </thead>
          <tbody>
            {stockQuatities.map((stock, index) => {
              return (
                <tr key={index}>
                  <td width="12%">
                    <div className="text-title">
                      <span>{stock.id}</span>
                    </div>
                  </td>
                  <BodyImageWithInfoColumn
                    width="300px"
                    imgSrc={`${process.env.REACT_APP_API_URL}/file/${stock.product_photo}`}
                    roundedImg="0px"
                    textName={stock.product_name}
                    textDesc={stock.product_sku}
                  />
                  <td width="100px">
                    <div className="text item-center">
                      <Badge
                        label={stock.status === 2 ? "Success" : "Failed"}
                        labelColor={stock.status === 2 ? "#067647" : "#B42318"}
                        backgroundColor={
                          stock.status === 2 ? "#ECFDF3" : "#FEF3F2"
                        }
                      />
                    </div>
                  </td>
                  <td width="5%">
                    <div className="text item-center">
                      <span>{stock.stock}</span>
                    </div>
                  </td>
                  <td width="15%">
                    <div className="text item-center">
                      <span>{stock.warehouse}</span>
                    </div>
                  </td>
                  <td width="15%">
                    <div className="text item-center">
                      <span>{stock.created_by}</span>
                    </div>
                  </td>
                  <td width="20%">
                    <div className="text">
                      <span>
                        {stringToDate(
                          stock?.created_at,
                          "dd month yyyy hours:minutes"
                        )}
                      </span>
                    </div>
                  </td>
                  <td width="10%">
                    <div className="cta-wrapper">
                      <button
                        onClick={() =>
                          navigate("/inventory/stock-transfer/add", {
                            state: { id: stock.id },
                          })
                        }
                      >
                        <EYE_ICON />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Pagination
          activePage={activePage}
          totalPage={totalPage}
          onChange={onChangePagination}
        />
      </div>

      {showModalAdd && (
        <div className="stock-modal-wrapper">
          <Modal
            setIsOpen={() => setShowModalAdd(!showModalAdd)}
            type="transfer"
            content={
              <div className="modal-content">
                <div className="header">
                  <span className="text-title">Add Stock Transfer</span>
                  <span className="text">
                    Choose the desired product from the available options below.
                  </span>
                </div>
                <div className="column">
                  <span className="label">Product</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select for product"
                      value={product}
                      options={listProduct?.map((product: Product) => {
                        const option = {
                          label: product.name,
                          value: product.id,
                          desc: product.master_sku,
                          // imgSrc: `${process.env.REACT_APP_API_URL}/file/${product?.images[0]?.path}`,
                        };
                        return option;
                      })}
                      onChange={(e) => setProduct(e)}
                      disabled={false}
                      optionType="product-option"
                      width="592px"
                    />
                  </div>
                </div>
                <div className="column">
                  <span className="label">Source Warehouse</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select warehouse source"
                      value={warehouseSource}
                      options={listWarehouse?.map((warehouse: Warehouse) => {
                        const option = {
                          label: warehouse.name,
                          value: warehouse.id,
                        };
                        return option;
                      })}
                      onChange={(e) => {
                        setWarehouseSource(e);
                        setWarehouseTarget({});
                      }}
                      disabled={false}
                      optionType="text-option"
                      width="592px"
                    />
                  </div>
                </div>
                <div className="column">
                  <span className="label">Target Warehouse</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select warehouse target"
                      value={warehouseTarget}
                      options={listWarehouse
                        .filter(
                          (warehouse) => warehouse.id !== warehouseSource?.value
                        )
                        .map((warehouse) => {
                          const option = {
                            label: warehouse.name,
                            value: warehouse.id,
                          };
                          return option;
                        })}
                      onChange={(e) => setWarehouseTarget(e)}
                      disabled={!warehouseSource}
                      optionType="text-option"
                      width="592px"
                    />
                  </div>
                </div>
                <div className="column">
                  <div className="upload text-align">
                    <SelectImage
                      onChange={handleFileUpload}
                      disabled={false}
                      displayIcon={true}
                      desc=".csv-file"
                      width="592px"
                      isError={isErrorFile}
                      errorText="Selected file must be .CSV"
                    />
                  </div>
                </div>
                <div className="column">
                  <span className="label">Set Stock Status</span>
                  <div className="input">
                    <Dropdown
                      placeHolder="Select warehouse"
                      value={stockStatus}
                      options={STOCK_STATUS_OPTIONS}
                      onChange={(e) => setStockStatus(e)}
                      disabled={false}
                      optionType="text-option"
                      width="592px"
                    />
                  </div>
                </div>
              </div>
            }
            footer={
              <div className="stock-modal-btn-wrapper">
                <Button
                  type="secondary"
                  label="Cancel"
                  onClick={() => setShowModalAdd(!showModalAdd)}
                />
                <Button
                  type="primary"
                  label={isFetch ? "Uploading" : "Continue"}
                  onClick={createTransferStock}
                  disabled={!fileCsv || isErrorFile || isFetch}
                />
              </div>
            }
          />
        </div>
      )}
      <Toaster />
    </>
  );
};

export default TableSection;
